import {auth, cloudFunctionConfig} from "../../firebase/client-app";
import axios from "axios";
import _ from "lodash";
import * as querystring from "querystring";

export {
    syncShopifyProducts,
    getShopifyProductsSyncStatus,
    initiateInstagramPostSchedule,
    initiateShopifyBulkProductUpdates,
    getShopifyProductUpdatesStatus,
    syncShopifyBlogsList,
    syncShopifyCollectionsList,
    initShopifyCollectionsDetailsUpdate,
    initPublishArticleToShopifyBlog,
    syncPrintfulStores,
    syncPrintfulCategories,
    syncPrintfulProductTypes,
    syncPrintfulProducts,
    syncPrintfulSyncProducts,
    initiateShopifyProductPriceSync,
    getShopifyProductPricesSyncStatus,
    bulkUpdateDesignContent,
    getExternalImageDownloadUrl,
    uploadShopifyCollectionImage,
}

const getExternalImageDownloadUrl = async (imageUrl, imageId = '', type = '') => {
    let url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.getImageDownloadUrl;

    let requestQueryParams = [];
    if (!_.isEmpty(imageUrl)) {
        requestQueryParams.push("url=" + imageUrl);
    }

    if (!_.isNaN(imageId)) {
        requestQueryParams.push("imageId=" + imageId);
    }

    if (!_.isEmpty(type)) {
        requestQueryParams.push("type=" + type);
    }

    url += '?' + _.join(requestQueryParams, '&');
    return await makeGetCall(url);
}

const bulkUpdateDesignContent = async (id) => {
    let url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.bulkUpdateDesignContentUrl;

    let requestQueryParams = [];
    if (!_.isEmpty(id)) {
        requestQueryParams.push("id=" + id);
    }

    url += '?' + _.join(requestQueryParams, '&');
    return await makeGetCall(url);
}

const syncPrintfulStores = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.syncPrintfulStoresUrl;
    return await makeGetCall(url);
}

const syncPrintfulCategories = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.syncPrintfulCategoriesUrl;
    return await makeGetCall(url);
}

const syncPrintfulProductTypes = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.syncPrintfulProductTypesUrl;
    return await makeGetCall(url);
}

const syncPrintfulProducts = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.syncPrintfulProductsUrl;
    return await makeGetCall(url);
}

const syncPrintfulSyncProducts = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.syncPrintfulSyncProductsUrl;
    return await makeGetCall(url);
}

const initiateShopifyProductPriceSync = async (id) => {
    let url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.initiateShopifyProductPriceSyncUrl;

    let requestQueryParams = [];
    if (!_.isEmpty(id)) {
        requestQueryParams.push("id=" + id);
    }

    url += '?' + _.join(requestQueryParams, '&');
    return await makeGetCall(url);
}

const getShopifyProductPricesSyncStatus = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.getShopifyProductPricesSyncStatusUrl;
    return await makeGetCall(url);
}

const initiateShopifyBulkProductUpdates = async (id) => {
    let url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.initiateShopifyBulkProductUpdatesUrl;

    let requestQueryParams = [];
    if (!_.isEmpty(id)) {
        requestQueryParams.push("id=" + id);
    }

    url += '?' + _.join(requestQueryParams, '&');
    return await makeGetCall(url);
}

const getShopifyProductUpdatesStatus = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.getShopifyProductUpdatesStatusUrl;
    return await makeGetCall(url);
}

const syncShopifyProducts = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.syncShopifyProductsUrl;
    return await makeGetCall(url);
}

const getShopifyProductsSyncStatus = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.getShopifyProductsSyncStatusUrl;
    return await makeGetCall(url);
}

const syncShopifyBlogsList = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.syncShopifyBlogsListUrl;
    return await makeGetCall(url);
}

const syncShopifyCollectionsList = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.syncShopifyCollectionsListUrl;
    return await makeGetCall(url);
}

const initShopifyCollectionsDetailsUpdate = async () => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.updateShopifyCollectionsDetailsUrl;
    return await makeGetCall(url);
}

const initPublishArticleToShopifyBlog = async (article) => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.initPublishArticleToShopifyBlogUrl;
    return await makePostCall(url, article);
}

const uploadShopifyCollectionImage = async (collectionDetail) => {
    const url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.uploadShopifyCollectionImageUrl;
    return await makePostCall(url, collectionDetail);
}

const initiateInstagramPostSchedule = async (id?, postDate?, postTime?) => {
    let url = cloudFunctionConfig.baseUrl + cloudFunctionConfig.initiateInstagramPostScheduleUrl;
    let requestQueryParams = [];

    if (!_.isEmpty(id)) {
        requestQueryParams.push("id=" + id);
    }

    if (!_.isEmpty(postDate)) {
        requestQueryParams.push("date=" + postDate);

        if (!_.isEmpty(postTime)) {
            requestQueryParams.push("time=" + postTime);
        }
    }

    url += '?' + _.join(requestQueryParams, '&');
    return await makeGetCall(url);
}

const makeGetCall = async (url, headers?) => {
    const {data} = await axios.get(url, {headers});
    return data;
}

const makePostCall = async (url, inputData, headers?) => {
    const options = {
        method: 'POST',
        body: JSON.stringify(inputData)
    }

    const response = await fetch(url, options);
    return response.json();
}
